import { z } from "zod";
import { searchParam } from "@amber/ui";
import { DISCOVERED_FILTERS, POST_AUTHORS } from "../contracts/index";

export const backlogSearchSchema = z.object({
  status: searchParam(z.string()),
  source: searchParam(z.string()),
  readiness: searchParam(z.string()),
  person: searchParam(z.string()),
  platform: searchParam(z.string()),
  stage: searchParam(z.string()),
  family: searchParam(z.string()),
  type: searchParam(z.string()),
  discovered: searchParam(z.enum(DISCOVERED_FILTERS)),
  language: searchParam(z.string()),
  counted: searchParam(z.literal("yes")),
  archived: searchParam(z.literal("yes")),
  passed: searchParam(z.enum(["context", "attribution"])),
  overdue: searchParam(z.literal("yes")),
  through: searchParam(z.literal("no")),
  corrected: searchParam(z.enum(["yes", "no"])),
  authors: searchParam(z.enum(POST_AUTHORS)),
  q: searchParam(z.string()),
  sort: searchParam(z.string()),
  // DI-114: links from before checkpoint 44 say group=off; the router rewrites the address to the parsed group=none.
  group: searchParam(z.enum(["status", "none", "off"]).transform((g) => (g === "off" ? "none" : g))),
});
export type BacklogSearch = z.infer<typeof backlogSearchSchema>;
export const backlogRouteSearchSchema = backlogSearchSchema.extend({ add: searchParam(z.string()) });

export const sourcesSearchSchema = z.object({
  tab: searchParam(z.enum(["platforms", "sources", "gaps"])),
  platform: searchParam(z.string()),
  health: searchParam(z.string()),
  person: searchParam(z.string()),
  q: searchParam(z.string()),
  source: searchParam(z.string()),
  window: searchParam(z.coerce.number().pipe(z.union([z.literal(30), z.literal(90), z.literal(180)]))),
  gaps: searchParam(z.enum(["open", "resolved"])),
});
export type SourcesSearch = z.infer<typeof sourcesSearchSchema>;
export const sourcesRouteSearchSchema = sourcesSearchSchema.extend({ add: searchParam(z.literal("1")) });
